import React, { useEffect, useState, useRef } from "react";
import api from "../../utils/api";
import APIConstant from "../../utils/constant";
import Loader from "components/Shared/Loader/Loader";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { OverlayPanel } from "primereact/overlaypanel";
import { SelectButton } from "primereact/selectbutton";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import moment from "moment";
import { Tooltip } from "@material-ui/core";
import cogoToast from "cogo-toast";

const filterOptions = ["Today", "7 Days", "30 Days"];

const SalesTypeOptions = [
  { label: "Inter-State", value: "INTERSTATE" },
  { label: "Intra-State", value: "INTRA-STATE" },
];

const BusinessTypeOptions = [
  { label: "B2B", value: "B2B" },
  { label: "B2C", value: "B2C" },
];

const PaymentTypeOptions = [
  { label: "Upfront", value: "Upfront Payment" },
  { label: "Credit", value: "Credit" },
];

const SalesReportPage = () => {
  const initialFilterState = {
    FilterDate: "",
    FromDate: [new Date(), new Date()],
    IsGst: null,
    IsInclusive: null,
    Payment: [],
    SalesType: [],
    BusinessType: [],
    PaymentMode: [],
    Item: [],
    Customer: [],
  };

  const actionBodyTemplateSrNo = (data, props) => props.rowIndex + 1;

  const [salesReportList, setSalesReportList] = useState([]);
  const [filteredSalesReportList, setFilteredSalesReportList] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [filterData, setFilterData] = useState(initialFilterState);
  const [userId, setUserId] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);

  const op = useRef(null);

  /* ================= INIT ================= */
  useEffect(() => {
    const uid = localStorage.getItem("Infodata");
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(uid);
    getVariants(uid);
    getCustomers(uid);
    getPaymentModes(uid);
  }, []);

  /* ================= DATE FILTER ================= */
  useEffect(() => {
    if (!filterData.FilterDate) return;

    const today = moment();
    let range = null;

    if (filterData.FilterDate === "Today") {
      range = [today.startOf("day").toDate(), today.endOf("day").toDate()];
    } else if (filterData.FilterDate === "7 Days") {
      range = [
        moment()
          .subtract(6, "days")
          .startOf("day")
          .toDate(),
        today.endOf("day").toDate(),
      ];
    } else if (filterData.FilterDate === "30 Days") {
      range = [
        moment()
          .subtract(29, "days")
          .startOf("day")
          .toDate(),
        today.endOf("day").toDate(),
      ];
    }

    if (range) {
      setFilterData((prev) => ({ ...prev, FromDate: range }));
    }
  }, [filterData.FilterDate]);

  /* ================= DROPDOWNS ================= */
  const getVariants = async (UserId) => {
    const res = await api.post(APIConstant.path.GetVariantList, { UserId });
    if (res.Success === 1) setVariantList(res.Data);
  };

  const getCustomers = async (UserId) => {
    const res = await api.post(APIConstant.path.GetNetworkByUserType, {
      UserId,
      UserType: "Customer",
    });
    if (res.Success === 1) setCustomerList(res.Data);
  };

  const getPaymentModes = async (UserId) => {
    const res = await api.post(APIConstant.path.GetPaymentModeMaster, {
      UserId,
    });
    if (res.Success === 1) setPaymentModeList(res.Data);
  };

  /* ================= API ================= */
  const GetSalesReport = async () => {
    try {
      Loader.show();
      const res = await api.post(APIConstant.path.GetSalesReport, {
        UserId: userId,
        Filters: filterData,
      });

      if (res.Success === 1) {
        setSalesReportList(res.Data.Details);
        setFilteredSalesReportList(res.Data.Details);
        op.current.hide();
      } else {
        setSalesReportList([]);
        setFilteredSalesReportList([]);
      }
      Loader.hide();
    } catch (err) {
      console.log(err);
    }
  };

  /* ================= SEARCH ================= */
  const handleGlobalFilter = (e) => {
    const value = e.target.value;
    setGlobalFilter(value);

    setFilteredSalesReportList(
      salesReportList.filter((x) =>
        x.ItemName?.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  /* ================= EXPORT ================= */
  const exportToExcel = async (type) => {
    try {
      const res = await api.post(APIConstant.path.GenerateSalesReportExcel, {
        UserId: userId,
        Filters: filterData,
        ExportType: type,
      });

      if (res.Success === 1) {
        cogoToast.success(res?.Message);
      } else {
        cogoToast.error(res.Message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  /* ================= UI ================= */
  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-chart-line"></i>
          <h2>Sales Report</h2>
        </div>

        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-position-relative">
            <InputText
              className="searchbar"
              value={globalFilter}
              onChange={handleGlobalFilter}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!globalFilter && <i className="icon-search"></i>}
          </div>

          {userPageAccess.includes("Sales Report Export Excel") && (
            <>
              <Tooltip title="Export to Excel" placement="top">
                <div
                  className="e-add-btn"
                  onClick={() => exportToExcel("DETAILS")}
                >
                  <i className="pi pi-file-excel"></i>
                </div>
              </Tooltip>

              <Tooltip title="Export to Excel Summary">
                <div
                  className="e-add-btn"
                  onClick={() => exportToExcel("SUMMARY")}
                >
                  <i className="pi pi-file-excel"></i>
                </div>
              </Tooltip>
            </>
          )}

          <Button
            onClick={(e) => op.current.toggle(e)}
            icon="icon-filter"
            rounded
            className="wb-search-btn p-ml-2"
          />
        </div>
      </div>

      <OverlayPanel
        ref={op}
        style={{ width: 700 }}
        className="wayment-slip-filter"
      >
        <div>
          <div role="menu">
            <div className="p-grid p-p-2 trip-filter-box">
              {/* ================= DATE FILTER ================= */}
              <div className="p-col-12 p-md-12 p-pt-2">
                <div className="p-w-100">
                  <div className="custom-inputs">
                    <label>Select Date</label>
                    <div className="p-d-flex p-ai-center">
                      <SelectButton
                        className="wb-filter-dt"
                        value={filterData.FilterDate}
                        options={filterOptions}
                        onChange={(e) =>
                          setFilterData((prev) => ({
                            ...prev,
                            FilterDate: e.value,
                            FromDate: null,
                          }))
                        }
                      />
                      <Calendar
                        dateFormat="dd/mm/yy"
                        className="p-w-100 p-mt-2"
                        placeholder="Start Date - End Date"
                        value={filterData.FromDate}
                        selectionMode="range"
                        onChange={(e) =>
                          setFilterData((prev) => ({
                            ...prev,
                            FilterDate: null,
                            FromDate: e.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* ================= GST / NON-GST ================= */}
              <div className="p-col-12 p-md-6 p-pt-2">
                <div className="custom-inputs">
                  <label>GST</label>
                  <SelectButton
                    value={filterData.IsGst}
                    options={[
                      { label: "GST", value: true },
                      { label: "Non GST", value: false },
                    ]}
                    onChange={(e) =>
                      setFilterData((prev) => ({
                        ...prev,
                        IsGst: e.value,
                      }))
                    }
                  />
                </div>
              </div>

              {/* ================= INCLUSIVE / EXCLUSIVE ================= */}
              <div className="p-col-12 p-md-6 p-pt-2">
                <div className="custom-inputs">
                  <label>Inclusive</label>
                  <SelectButton
                    value={filterData.IsInclusive}
                    options={[
                      { label: "Inclusive", value: true },
                      { label: "Exclusive", value: false },
                    ]}
                    onChange={(e) =>
                      setFilterData((prev) => ({
                        ...prev,
                        IsInclusive: e.value,
                      }))
                    }
                  />
                </div>
              </div>

              {/* ================= PAYMENT TYPE ================= */}
              <div className="p-col-12 p-md-6 p-pt-2">
                <div className="custom-inputs">
                  <label>Payment Type</label>
                  <MultiSelect
                    className="p-w-100 p-mt-1"
                    value={filterData.Payment}
                    options={PaymentTypeOptions}
                    optionLabel="label"
                    placeholder="Select Payment Type"
                    display="chip"
                    onChange={(e) =>
                      setFilterData((prev) => ({
                        ...prev,
                        Payment: e.value,
                      }))
                    }
                  />
                </div>
              </div>

              {/* ================= SALES TYPE ================= */}
              <div className="p-col-12 p-md-6 p-pt-2">
                <div className="custom-inputs">
                  <label>Sales Type</label>
                  <MultiSelect
                    className="p-w-100 p-mt-1"
                    value={filterData.SalesType}
                    options={SalesTypeOptions}
                    optionLabel="label"
                    placeholder="Select Sales Type"
                    display="chip"
                    onChange={(e) =>
                      setFilterData((prev) => ({
                        ...prev,
                        SalesType: e.value,
                      }))
                    }
                  />
                </div>
              </div>

              {/* ================= BUSINESS TYPE ================= */}
              <div className="p-col-12 p-md-6 p-pt-2">
                <div className="custom-inputs">
                  <label>Business Type</label>
                  <MultiSelect
                    className="p-w-100 p-mt-1"
                    value={filterData.BusinessType}
                    options={BusinessTypeOptions}
                    optionLabel="label"
                    placeholder="Select Business Type"
                    display="chip"
                    onChange={(e) =>
                      setFilterData((prev) => ({
                        ...prev,
                        BusinessType: e.value,
                      }))
                    }
                  />
                </div>
              </div>

              {/* ================= PAYMENT MODE ================= */}
              <div className="p-col-12 p-md-6 p-pt-2">
                <div className="custom-inputs">
                  <label>Payment Mode</label>
                  <MultiSelect
                    className="p-w-100 p-mt-1"
                    value={filterData.PaymentMode}
                    options={paymentModeList}
                    optionLabel="label"
                    placeholder="Select Payment Mode"
                    display="chip"
                    onChange={(e) =>
                      setFilterData((prev) => ({
                        ...prev,
                        PaymentMode: e.value,
                      }))
                    }
                  />
                </div>
              </div>

              {/* ================= VARIANT ================= */}
              <div className="p-col-12 p-md-6 p-pt-2">
                <div className="custom-inputs">
                  <label>Variants</label>
                  <MultiSelect
                    className="p-w-100 p-mt-1"
                    value={filterData.Item}
                    options={variantList}
                    optionLabel="label"
                    placeholder="Select Variants"
                    display="chip"
                    filter
                    onChange={(e) =>
                      setFilterData((prev) => ({
                        ...prev,
                        Item: e.value,
                      }))
                    }
                  />
                </div>
              </div>

              {/* ================= CUSTOMER ================= */}
              <div className="p-col-12 p-md-6 p-pt-2">
                <div className="custom-inputs">
                  <label>Customer</label>
                  <MultiSelect
                    className="p-w-100 p-mt-1"
                    value={filterData.Customer}
                    options={customerList}
                    optionLabel="label"
                    placeholder="Select Customer"
                    display="chip"
                    filter
                    onChange={(e) =>
                      setFilterData((prev) => ({
                        ...prev,
                        Customer: e.value,
                      }))
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ================= FOOTER ================= */}
          <div className="noti-footer">
            <div className="p-d-flex p-ml-2 p-mb-1">
              <Button
                className="primary-btn1"
                onClick={() => {
                  setFilterData(initialFilterState);
                  op.current.hide();
                }}
              >
                Reset
              </Button>

              <Button className="primary-btn p-ml-2" onClick={GetSalesReport}>
                Filter
              </Button>
            </div>
          </div>
        </div>
      </OverlayPanel>

      <hr />

      <div className="e-common-master-table daily-production-table">
        <DataTable
          className="main-table table-td e-c-table"
          value={filteredSalesReportList}
          scrollable
          scrollWidth="auto"
          responsiveLayout="scroll"
          totalRecords={filteredSalesReportList.length}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          // columnResizeMode="fit"
        >
          <Column header="Sr.No" body={actionBodyTemplateSrNo} />
          <Column field="InvoiceNo" header="Invoice No" />
          <Column field="InvoiceDate" header="Invoice Date" />
          <Column field="TransactionType" header="Transaction Type" />
          <Column field="BusinessType" header="Sales Type" />
          <Column field="CustomerName" header="Customer Name" />
          <Column field="GSTIN" header="GSTIN" />
          <Column field="PlaceOfSupply" header="Place of Supply" />
          <Column field="ItemCategory" header="Item Category" />
          <Column field="ItemName" header="Item Name" />
          <Column field="HSNCode" header="HSNCode" />
          <Column field="Qty" header="Qty" />
          <Column field="UOM" header="UOM" />
          <Column field="Rate" header="Rate" />
          <Column field="TaxableValue" header="Taxable Value" />
          <Column field="CGST" header="CGST" />
          <Column field="SGST" header="SGST" />
          <Column field="IGST" header="IGST" />
          <Column field="InvoiceValue" header="Invoice Value" />
          <Column field="PaymentMode" header="Payment Mode" />
          <Column field="Payment" header="Payment Type" />
          <Column field="Subwarehouse" header="Subwarehouse" />
        </DataTable>
      </div>
    </div>
  );
};

export default SalesReportPage;
